var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcShoppingNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 52,
    viewBox: "0 0 44 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6027 2V43.4332V47.985C42.6027 49.0896 41.7073 49.985 40.6027 49.985H36.2539H9.38232V49.9297",
    stroke: "#8364BE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38232 37.1214V37.066V7.64747V2",
    stroke: "#8364BE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7393 17.7893H32.1444",
    stroke: "#8364BE",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7393 25.9922H28.8634",
    stroke: "#8364BE",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38232 2L14.9191 7.53674L20.4558 2L25.9925 7.53674L31.5293 2L37.066 7.53674L42.6027 2",
    stroke: "#8364BE",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47308 38.4697C3.71208 39.0562 3.0941 39.8077 2.66572 40.6677C2.23733 41.5276 2.00971 42.4736 2 43.4343C2.02863 45.1662 2.73061 46.8189 3.95713 48.042C5.18366 49.265 6.83829 49.9624 8.57026 49.9861C8.84061 50.0051 9.11196 50.0051 9.38231 49.9861",
    stroke: "#8364BE",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1164 38.4697C32.3435 39.0476 31.7147 39.7965 31.2793 40.6577C30.8439 41.519 30.6136 42.4693 30.6064 43.4343C30.6351 45.1662 31.3371 46.8189 32.5636 48.042C33.7901 49.265 35.4447 49.9624 37.1767 49.9861",
    stroke: "#8364BE",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.116 38.4697H4.47266",
    stroke: "#8364BE",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShoppingNotes);
export default __webpack_public_path__ + "static/media/ic-shopping-notes.b9c22ba9ae04fc720ce9cd50841d9abd.svg";
export { ForwardRef as ReactComponent };